import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './CapaPed.css'
import brasao from '../../assets/brasilNav.png'

const CapaPed = (props) => {
    const [processo, setProcesso] = useState({ dataCriacao: '' })
    const id = props.id || window.location.pathname.slice(15)

    useEffect(() => {
        const url = `/api/ped/getPed/${id}`
        axios(url)
            .then(res => {
                setProcesso(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    const voltar = () => {
        window.location = `/etica/documentosPed/${processo._id}`
    }

    const imprimir = (e) => {
        window.print()
    }
    return (
        <React.Fragment>
            <div className="capaPedCaixaBranca">
                <img src={brasao} alt="Brasil" className='brasaoPed' />
                <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                <div className="capaPedCaixaVerde">PROCESSO ÉTICO DISCIPLINAR</div>
                <div className="capaPedCaixaVerdeNumero">PED Nº {processo.numeroPed}</div>
                <div className="capaPedCaixaVerdeRepresentante">
                    <span className="capaPedRepresentante">Representante</span>
                    <div className="capaPedElement">{processo.representante}</div>
                    <div className="capaPedElement">{processo.numeroPaf}</div>
                </div>
                <div className="capaPedCaixaVerdeRepresentante">
                    <span className="capaPedRepresentante">Representado</span>
                    <div className="capaPedElement">{processo.representado}</div>
                    <div className="capaPedElement">{processo.numeroCrefito}</div>
                </div>
                <div className="capaPedCaixaVerdeInfracoes">
                    <span className="capaPedRepresentante">Infrações</span>
                    <div className="capaPedElement">{RenderInfracoes()}</div>
                </div>
            </div>
            <button className="botaoNPed" onClick={e => voltar(e)}>VOLTAR</button>
            <button className="botaoNPed"
                style={{ display: 'block', margin: 'auto', marginTop: '1vh' }}
                onClick={e => imprimir(e)}>IMPRIMIR</button>
        </React.Fragment>
    )

    function RenderInfracoes() {
        const rows = []
        if (processo.infracoes && processo.infracoes.length > 0) {
            processo.infracoes.map((el, index) => {
                if (el.hasOwnProperty("_id")) {
                    if (!el.outraInfracao) {
                        rows.push(<React.Fragment key={index}>{el.infracao}<br /></React.Fragment>)
                    } else {
                        rows.push(<React.Fragment key={index}>{el.outraInfracao}<br /></React.Fragment>)
                    }
                }
                else {
                    let concatText = ""
                    for (let key in el) {
                        concatText += el[key];
                    }
                    rows.push(<React.Fragment key={index}>{concatText}<br /></React.Fragment>)
                }
            })
        }
        return rows
    }
}

export default CapaPed